import React from "react";
import {
    TableContentForLeafCollectionVarianceReport,
    TableContentForSumLeafCollectionVarianceReport
} from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const fieldColumnNames = this.props.fieldColumnNames;
        const factoryColumnNames = this.props.factoryColumnNames;
        const fullTotalRow = this.props.fullTotalRow;
        const sumTableData = this.props.sumTableData;
        const sumTableContentRownames = this.props.sumTableContentRownames;
        const sumTableTotal = this.props.sumTableTotal;

        return (
            <div>
                <h3><center><u>Leaf Collection Variance Details Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                    <div className="col"><b>Variance: </b> {searchData.varinaceLimit.trim() !== "" ? ("+/-" + searchData.varinaceLimit) : ""}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <div>
                    <div className="row pb-3">
                        <div className="col-md-6">
                            <table>
                                <thead>
                                    <tr style={{ fontWeight: "bold" }}>
                                        <th>Route Name</th>
                                        <th>Bag Count</th>
                                        <th>Field Gross /Kg</th>
                                        <th>Factory Gross /Kg</th>
                                        <th>G/L/X</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForSumLeafCollectionVarianceReport
                                        data={sumTableData}
                                        contentRowNames={sumTableContentRownames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th style={{ fontWeight: "bold" }}>Total</th>
                                        <th style={{ textAlign: "right",fontWeight: "bold" }}>{sumTableTotal.fieldNumberOfUnits}</th>
                                        <th style={{ textAlign: "right",fontWeight: "bold" }}>{sumTableTotal.fieldGrossAmount !== undefined ?
                                            sumTableTotal.fieldGrossAmount.toFixed(2) : (0).toFixed(2)}</th>
                                        <th style={{ textAlign: "right",fontWeight: "bold" }}>{sumTableTotal.factoryGrossAmount !== undefined ?
                                            sumTableTotal.factoryGrossAmount.toFixed(2) : (0).toFixed(2)}</th>
                                        <th style={{ textAlign: "right",fontWeight: "bold" }}>{sumTableTotal.glx !== undefined ?
                                            sumTableTotal.glx.toFixed(2) : (0).toFixed(2)} </th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <table id="leafCollectionSummaryPdf">
                                <thead>
                                    <tr>
                                        <th rowSpan="2">Route Code</th>
                                        <th rowSpan="2">Route Name</th>
                                        <th rowSpan="2">Card Number</th>
                                        <th rowSpan="2">Reg Number</th>
                                        <th rowSpan="2">Date</th>
                                        <th rowSpan="2">Time</th>
                                        <th rowSpan="2">Leaf Type</th>
                                        <th rowSpan="2">Tag Number</th>
                                        <th style={{ textAlign: "center" }} colSpan={2 + fieldColumnNames.length}>Field</th>
                                        <th style={{ textAlign: "center" }} colSpan={2 + factoryColumnNames.length}>Factory</th>
                                        <th rowSpan="2">G/L/X</th>
                                    </tr>
                                    <tr>
                                        <th>Gross /Kg</th>
                                        {fieldColumnNames.map((x, index) => {
                                            return (
                                                <th scope="col" key={index}>{x}</th>
                                            )
                                        })}
                                        <th>Net /Kg</th>
                                        <th>Gross /Kg</th>
                                        {factoryColumnNames.map((x, index) => {
                                            return (
                                                <th scope="col" key={index}>{x}</th>
                                            )
                                        })}
                                        <th>Net /Kg</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForLeafCollectionVarianceReport
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan="7">Total</th>
                                        <th style={{ textAlign: "right" }}>{fullTotalRow.bagCount}</th>
                                        {contentRowNames.map((x, i) => {
                                            var res = fullTotalRow.find(y => y.name === x);

                                            if (res) {
                                                return (
                                                    <th key={i} style={{ textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                );
                                            } else if (res === undefined && x.includes("_Kg")) {
                                                return (
                                                    <th key={i} style={{ textAlign: "right" }}>{(0).toFixed(2)}</th>
                                                );
                                            }

                                        })}
                                        <th style={{ textAlign: "right",fontWeight: "bold" }}>{fullTotalRow.glx !== undefined ?
                                        fullTotalRow.glx.toFixed(2) : (0).toFixed(2)} </th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}